export const countryCodeFn = () => {
  var countryData = [

    {
      'code': 'US',
      'en': 'United States of America (USA)',
      'name': '美國'
    },
    {
      'code': 'AR',
      'en': 'Argentina',
      'name': '阿根廷'
    },
    {
      'code': 'AD',
      'en': 'Andorra',
      'name': '安道爾'
    },
    {
      'code': 'AE',
      'en': 'United Arab Emirates',
      'name': '阿聯酋'
    },
    {
      'code': 'AF',
      'en': 'Afghanistan',
      'name': '阿富汗'
    },
    {
      'code': 'AG',
      'en': 'Antigua & Barbuda',
      'name': '安提瓜和巴布達'
    },
    {
      'code': 'AI',
      'en': 'Anguilla',
      'name': '安圭拉'
    },
    {
      'code': 'AL',
      'en': 'Albania',
      'name': '阿爾巴尼亞'
    },
    {
      'code': 'AM',
      'en': 'Armenia',
      'name': '亞美尼亞'
    },
    {
      'code': 'AO',
      'en': 'Angola',
      'name': '安哥拉'
    },
    {
      'code': 'AQ',
      'en': 'Antarctica',
      'name': '南極洲'
    },
    {
      'code': 'AS',
      'en': 'American Samoa',
      'name': '美屬薩摩亞'
    },
    {
      'code': 'AT',
      'en': 'Austria',
      'name': '奧地利'
    },
    {
      'code': 'AU',
      'en': 'Australia',
      'name': '澳大利亞'
    },
    {
      'code': 'AW',
      'en': 'Aruba',
      'name': '阿魯巴'
    },
    {
      'code': 'AX',
      'en': 'Aland Island',
      'name': '奧蘭群島'
    },
    {
      'code': 'AZ',
      'en': 'Azerbaijan',
      'name': '阿塞拜疆'
    },
    {
      'code': 'BA',
      'en': 'Bosnia & Herzegovina',
      'name': '波黑'
    },
    {
      'code': 'BB',
      'en': 'Barbados',
      'name': '巴巴多斯'
    },
    {
      'code': 'BD',
      'en': 'Bangladesh',
      'name': '孟加拉'
    },
    {
      'code': 'BE',
      'en': 'Belgium',
      'name': '比利時'
    },
    {
      'code': 'BF',
      'en': 'Burkina',
      'name': '布基納法索'
    },
    {
      'code': 'BG',
      'en': 'Bulgaria',
      'name': '保加利亞'
    },
    {
      'code': 'BH',
      'en': 'Bahrain',
      'name': '巴林'
    },
    {
      'code': 'BI',
      'en': 'Burundi',
      'name': '布隆迪'
    },
    {
      'code': 'BJ',
      'en': 'Benin',
      'name': '貝寧'
    },
    {
      'code': 'BL',
      'en': 'Saint Barthélemy',
      'name': '聖巴泰勒米島'
    },
    {
      'code': 'BM',
      'en': 'Bermuda',
      'name': '佰慕大'
    },
    {
      'code': 'BN',
      'en': 'Brunei',
      'name': '文萊'
    },
    {
      'code': 'BO',
      'en': 'Bolivia',
      'name': '玻利維亞'
    },
    {
      'code': 'BQ',
      'en': 'Caribbean Netherlands',
      'name': '荷蘭加勒比區'
    },
    {
      'code': 'BR',
      'en': 'Brazil',
      'name': '巴西'
    },
    {
      'code': 'BS',
      'en': 'The Bahamas',
      'name': '巴哈馬'
    },
    {
      'code': 'BT',
      'en': 'Bhutan',
      'name': '不丹'
    },
    {
      'code': 'BV',
      'en': 'Bouvet Island',
      'name': '布韋島'
    },
    {
      'code': 'BW',
      'en': 'Botswana',
      'name': '博茨瓦納'
    },
    {
      'code': 'BY',
      'en': 'Belarus',
      'name': '白俄羅斯'
    },
    {
      'code': 'BZ',
      'en': 'Belize',
      'name': '伯利茲'
    },
    {
      'code': 'CA',
      'en': 'Canada',
      'name': '加拿大'
    },
    {
      'code': 'CC',
      'en': 'Cocos (Keeling) Islands',
      'name': '科科斯群島'
    },
    {
      'code': 'CD',
      'en': 'Democratic Republic of the Congo',
      'name': '剛果（金）'
    },
    {
      'code': 'CF',
      'en': 'Central African Republic',
      'name': '中非'
    },
    {
      'code': 'CG',
      'en': 'Republic of the Congo',
      'name': '剛果（布）'
    },
    {
      'code': 'CH',
      'en': 'Switzerland',
      'name': '瑞士'
    },
    {
      'code': 'CI',
      'en': "Cote d'Ivoire",
      'name': '科特迪瓦'
    },
    {
      'code': 'CK',
      'en': 'Cook Islands',
      'name': '庫克群島'
    },
    {
      'code': 'CL',
      'en': 'Chile',
      'name': '智利'
    },
    {
      'code': 'CM',
      'en': 'Cameroon',
      'name': '喀麥隆'
    },
    {
      'code': 'CO',
      'en': 'Colombia',
      'name': '哥倫比亞'
    },
    {
      'code': 'CR',
      'en': 'Costa Rica',
      'name': '哥斯達黎加'
    },
    {
      'code': 'CU',
      'en': 'Cuba',
      'name': '古巴'
    },
    {
      'code': 'CV',
      'en': 'Cape Verde',
      'name': '佛得角'
    },
    {
      'code': 'CW',
      'en': 'Curacao',
      'name': '庫拉索'
    },
    {
      'code': 'CX',
      'en': 'Christmas Island',
      'name': '聖誕島'
    },
    {
      'code': 'CY',
      'en': 'Cyprus',
      'name': '塞浦路斯'
    },
    {
      'code': 'CZ',
      'en': 'Czech Republic',
      'name': '捷克'
    },
    {
      'code': 'DE',
      'en': 'Germany',
      'name': '德國'
    },
    {
      'code': 'DJ',
      'en': 'Djibouti',
      'name': '吉布提'
    },
    {
      'code': 'DK',
      'en': 'Denmark',
      'name': '丹麥'
    },
    {
      'code': 'DM',
      'en': 'Dominica',
      'name': '多米尼克'
    },
    {
      'code': 'DO',
      'en': 'Dominican Republic',
      'name': '多米尼加'
    },
    {
      'code': 'DZ',
      'en': 'Algeria',
      'name': '阿爾及利亞'
    },
    {
      'code': 'EC',
      'en': 'Ecuador',
      'name': '厄瓜多爾'
    },
    {
      'code': 'EE',
      'en': 'Estonia',
      'name': '愛沙尼亞'
    },
    {
      'code': 'EG',
      'en': 'Egypt',
      'name': '埃及'
    },
    {
      'code': 'EH',
      'en': 'Western Sahara',
      'name': '西撒哈拉'
    },
    {
      'code': 'ER',
      'en': 'Eritrea',
      'name': '厄立特裏亞'
    },
    {
      'code': 'ES',
      'en': 'Spain',
      'name': '西班牙'
    },
    {
      'code': 'ET',
      'en': 'Ethiopia',
      'name': '埃塞俄比亞'
    },
    {
      'code': 'FI',
      'en': 'Finland',
      'name': '芬蘭'
    },
    {
      'code': 'FJ',
      'en': 'Fiji',
      'name': '斐濟群島'
    },
    {
      'code': 'FK',
      'en': 'Falkland Islands',
      'name': '馬爾維納斯群島（福克蘭）'
    },
    {
      'code': 'FM',
      'en': 'Federated States of Micronesia',
      'name': '密克羅尼西亞聯邦'
    },
    {
      'code': 'FO',
      'en': 'Faroe Islands',
      'name': '法羅群島'
    },
    {
      'code': 'FR',
      'en': 'France',
      'name': '法國 法國'
    },
    {
      'code': 'GA',
      'en': 'Gabon',
      'name': '加蓬'
    },
    {
      'code': 'GB',
      'en': 'Great Britain (United Kingdom; England)',
      'name': '英國'
    },
    {
      'code': 'GD',
      'en': 'Grenada',
      'name': '格林納達'
    },
    {
      'code': 'GE',
      'en': 'Georgia',
      'name': '格魯吉亞'
    },
    {
      'code': 'GF',
      'en': 'French Guiana',
      'name': '法屬圭亞那'
    },
    {
      'code': 'GG',
      'en': 'Guernsey',
      'name': '根西島'
    },
    {
      'code': 'GH',
      'en': 'Ghana',
      'name': '加納'
    },
    {
      'code': 'GI',
      'en': 'Gibraltar',
      'name': '直布羅陀'
    },
    {
      'code': 'GL',
      'en': 'Greenland',
      'name': '格陵蘭'
    },
    {
      'code': 'GM',
      'en': 'Gambia',
      'name': '岡比亞'
    },
    {
      'code': 'GN',
      'en': 'Guinea',
      'name': '幾內亞'
    },
    {
      'code': 'GP',
      'en': 'Guadeloupe',
      'name': '瓜德羅普'
    },
    {
      'code': 'GQ',
      'en': 'Equatorial Guinea',
      'name': '赤道幾內亞'
    },
    {
      'code': 'GR',
      'en': 'Greece',
      'name': '希臘'
    },
    {
      'code': 'GS',
      'en': 'South Georgia and the South Sandwich Islands',
      'name': '南喬治亞島和南桑威奇群島'
    },
    {
      'code': 'GT',
      'en': 'Guatemala',
      'name': '危地馬拉'
    },
    {
      'code': 'GU',
      'en': 'Guam',
      'name': '關島'
    },
    {
      'code': 'GW',
      'en': 'Guinea-Bissau',
      'name': '幾內亞比紹'
    },
    {
      'code': 'GY',
      'en': 'Guyana',
      'name': '圭亞那'
    },
    {
      'code': 'HM',
      'en': 'Heard Island and McDonald Islands',
      'name': '赫德島和麥克唐納群島'
    },
    {
      'code': 'HN',
      'en': 'Honduras',
      'name': '洪都拉斯'
    },
    {
      'code': 'HK',
      'en': 'HongKong',
      'name': '香港'
    },
    {
      'code': 'HR',
      'en': 'Croatia',
      'name': '克羅地亞'
    },
    {
      'code': 'HT',
      'en': 'Haiti',
      'name': '海地'
    },
    {
      'code': 'HU',
      'en': 'Hungary',
      'name': '匈牙利'
    },
    {
      'code': 'ID',
      'en': 'Indonesia',
      'name': '印尼'
    },
    {
      'code': 'IE',
      'en': 'Ireland',
      'name': '愛爾蘭'
    },
    {
      'code': 'IL',
      'en': 'Israel',
      'name': '以色列'
    },
    {
      'code': 'IM',
      'en': 'Isle of Man',
      'name': '馬恩島'
    },
    {
      'code': 'IN',
      'en': 'India',
      'name': '印度'
    },
    {
      'code': 'IO',
      'en': 'British Indian Ocean Territory',
      'name': '英屬印度洋領地'
    },
    {
      'code': 'IQ',
      'en': 'Iraq',
      'name': '伊拉克'
    },
    {
      'code': 'IR',
      'en': 'Iran',
      'name': '伊朗'
    },
    {
      'code': 'IS',
      'en': 'Iceland',
      'name': '冰島'
    },
    {
      'code': 'IT',
      'en': 'Italy',
      'name': '意大利'
    },
    {
      'code': 'JE',
      'en': 'Jersey',
      'name': '澤西島'
    },
    {
      'code': 'JM',
      'en': 'Jamaica',
      'name': '牙買加'
    },
    {
      'code': 'JO',
      'en': 'Jordan',
      'name': '約旦'
    },
    {
      'code': 'JP',
      'en': 'Japan',
      'name': '日本'
    },
    {
      'code': 'KE',
      'en': 'Kenya',
      'name': '肯尼亞'
    },
    {
      'code': 'KG',
      'en': 'Kyrgyzstan',
      'name': '吉爾吉斯斯坦'
    },
    {
      'code': 'KH',
      'en': 'Cambodia',
      'name': '柬埔寨'
    },
    {
      'code': 'KI',
      'en': 'Kiribati',
      'name': '基裏巴斯'
    },
    {
      'code': 'KM',
      'en': 'The Comoros',
      'name': '科摩羅'
    },
    {
      'code': 'KN',
      'en': 'St. Kitts & Nevis',
      'name': '聖基茨和尼維斯'
    },
    {
      'code': 'KP',
      'en': 'North Korea',
      'name': '朝鮮'
    },
    {
      'code': 'KR',
      'en': 'South Korea',
      'name': '韓國'
    },
    {
      'code': 'KW',
      'en': 'Kuwait',
      'name': '科威特'
    },
    {
      'code': 'KY',
      'en': 'Cayman Islands',
      'name': '開曼群島'
    },
    {
      'code': 'KZ',
      'en': 'Kazakhstan',
      'name': '哈薩克斯坦'
    },
    {
      'code': 'LA',
      'en': 'Laos',
      'name': '老撾'
    },
    {
      'code': 'LB',
      'en': 'Lebanon',
      'name': '黎巴嫩'
    },
    {
      'code': 'LC',
      'en': 'St. Lucia',
      'name': '聖盧西亞'
    },
    {
      'code': 'LI',
      'en': 'Liechtenstein',
      'name': '列支敦士登'
    },
    {
      'code': 'LK',
      'en': 'Sri Lanka',
      'name': '斯裏蘭卡'
    },
    {
      'code': 'LR',
      'en': 'Liberia',
      'name': '利比裏亞'
    },
    {
      'code': 'LS',
      'en': 'Lesotho',
      'name': '萊索托'
    },
    {
      'code': 'LT',
      'en': 'Lithuania',
      'name': '立陶宛'
    },
    {
      'code': 'LU',
      'en': 'Luxembourg',
      'name': '盧森堡'
    },
    {
      'code': 'LV',
      'en': 'Latvia',
      'name': '拉脫維亞'
    },
    {
      'code': 'LY',
      'en': 'Libya',
      'name': '利比亞'
    },
    {
      'code': 'MAC',
      'en': 'Macao',
      'name': '澳門'
    },
    {
      'code': 'MA',
      'en': 'Morocco',
      'name': '摩洛哥'
    },
    {
      'code': 'MC',
      'en': 'Monaco',
      'name': '摩納哥'
    },
    {
      'code': 'MD',
      'en': 'Moldova',
      'name': '摩爾多瓦'
    },
    {
      'code': 'ME',
      'en': 'Montenegro',
      'name': '黑山'
    },
    {
      'code': 'MF',
      'en': 'Saint Martin (France)',
      'name': '法屬聖馬丁'
    },
    {
      'code': 'MG',
      'en': 'Madagascar',
      'name': '馬達加斯加'
    },
    {
      'code': 'MH',
      'en': 'Marshall islands',
      'name': '馬紹爾群島'
    },
    {
      'code': 'MK',
      'en': 'Republic of Macedonia (FYROM)',
      'name': '馬其頓'
    },
    {
      'code': 'ML',
      'en': 'Mali',
      'name': '馬裏'
    },
    {
      'code': 'MM',
      'en': 'Myanmar (Burma)',
      'name': '緬甸'
    },
    {
      'code': 'MN',
      'en': 'Mongolia',
      'name': '蒙古國'
    },
    {
      'code': 'MP',
      'en': 'Northern Mariana Islands',
      'name': '北馬裏亞納群島'
    },
    {
      'code': 'MQ',
      'en': 'Martinique',
      'name': '馬提尼克'
    },
    {
      'code': 'MR',
      'en': 'Mauritania',
      'name': '毛裏塔尼亞'
    },
    {
      'code': 'MS',
      'en': 'Montserrat',
      'name': '蒙塞拉特島'
    },
    {
      'code': 'MT',
      'en': 'Malta',
      'name': '馬耳他'
    },
    {
      'code': 'MU',
      'en': 'Mauritius',
      'name': '毛裏求斯'
    },
    {
      'code': 'MV',
      'en': 'Maldives',
      'name': '馬爾代夫'
    },
    {
      'code': 'MW',
      'en': 'Malawi',
      'name': '馬拉維'
    },
    {
      'code': 'MX',
      'en': 'Mexico',
      'name': '墨西哥'
    },
    {
      'code': 'MY',
      'en': 'Malaysia',
      'name': '馬來西亞'
    },
    {
      'code': 'MZ',
      'en': 'Mozambique',
      'name': '莫桑比克'
    },
    {
      'code': 'NA',
      'en': 'Namibia',
      'name': '納米比亞'
    },
    {
      'code': 'NC',
      'en': 'New Caledonia',
      'name': '新喀裏多尼亞'
    },
    {
      'code': 'NE',
      'en': 'Niger',
      'name': '尼日爾'
    },
    {
      'code': 'NF',
      'en': 'Norfolk Island',
      'name': '諾福克島'
    },
    {
      'code': 'NG',
      'en': 'Nigeria',
      'name': '尼日利亞'
    },
    {
      'code': 'NI',
      'en': 'Nicaragua',
      'name': '尼加拉瓜'
    },
    {
      'code': 'NL',
      'en': 'Netherlands',
      'name': '荷蘭'
    },
    {
      'code': 'NO',
      'en': 'Norway',
      'name': '挪威'
    },
    {
      'code': 'NP',
      'en': 'Nepal',
      'name': '尼泊爾'
    },
    {
      'code': 'NR',
      'en': 'Nauru',
      'name': '瑙魯'
    },
    {
      'code': 'NU',
      'en': 'Niue',
      'name': '紐埃'
    },
    {
      'code': 'NZ',
      'en': 'New Zealand',
      'name': '新西蘭'
    },
    {
      'code': 'OM',
      'en': 'Oman',
      'name': '阿曼'
    },
    {
      'code': 'PA',
      'en': 'Panama',
      'name': '巴拿馬'
    },
    {
      'code': 'PE',
      'en': 'Peru',
      'name': '秘魯'
    },
    {
      'code': 'PF',
      'en': 'French polynesia',
      'name': '法屬波利尼西亞'
    },
    {
      'code': 'PG',
      'en': 'Papua New Guinea',
      'name': '巴布亞新幾內亞'
    },
    {
      'code': 'PH',
      'en': 'The Philippines',
      'name': '菲律賓'
    },
    {
      'code': 'PK',
      'en': 'Pakistan',
      'name': '巴基斯坦'
    },
    {
      'code': 'PL',
      'en': 'Poland',
      'name': '波蘭'
    },
    {
      'code': 'PM',
      'en': 'Saint-Pierre and Miquelon',
      'name': '聖皮埃爾和密克隆'
    },
    {
      'code': 'PN',
      'en': 'Pitcairn Islands',
      'name': '皮特凱恩群島'
    },
    {
      'code': 'PR',
      'en': 'Puerto Rico',
      'name': '波多黎各'
    },
    {
      'code': 'PS',
      'en': 'Palestinian territories',
      'name': '巴勒斯坦'
    },
    {
      'code': 'PT',
      'en': 'Portugal',
      'name': '葡萄牙'
    },
    {
      'code': 'PW',
      'en': 'Palau',
      'name': '帕勞'
    },
    {
      'code': 'PY',
      'en': 'Paraguay',
      'name': '巴拉圭'
    },
    {
      'code': 'QA',
      'en': 'Qatar',
      'name': '卡塔爾'
    },
    {
      'code': 'RE',
      'en': 'Réunion',
      'name': '留尼汪'
    },
    {
      'code': 'RO',
      'en': 'Romania',
      'name': '羅馬尼亞'
    },
    {
      'code': 'RS',
      'en': 'Serbia',
      'name': '塞爾維亞'
    },
    {
      'code': 'RU',
      'en': 'Russian Federation',
      'name': '俄羅斯'
    },
    {
      'code': 'RW',
      'en': 'Rwanda',
      'name': '盧旺達'
    },
    {
      'code': 'SA',
      'en': 'Saudi Arabia',
      'name': '沙特阿拉伯'
    },
    {
      'code': 'SB',
      'en': 'Solomon Islands',
      'name': '所羅門群島'
    },
    {
      'code': 'SC',
      'en': 'Seychelles',
      'name': '塞舌爾'
    },
    {
      'code': 'SD',
      'en': 'Sudan',
      'name': '蘇丹'
    },
    {
      'code': 'SE',
      'en': 'Sweden',
      'name': '瑞典'
    },
    {
      'code': 'SG',
      'en': 'Singapore',
      'name': '新加坡'
    },
    {
      'code': 'SH',
      'en': 'St. Helena & Dependencies',
      'name': '聖赫勒拿'
    },
    {
      'code': 'SI',
      'en': 'Slovenia',
      'name': '斯洛文尼亞'
    },
    {
      'code': 'SJ',
      'en': 'Svalbard and Jan Mayen',
      'name': '斯瓦爾巴群島和揚馬延島'
    },
    {
      'code': 'SK',
      'en': 'Slovakia',
      'name': '斯洛伐克'
    },
    {
      'code': 'SL',
      'en': 'Sierra Leone',
      'name': '塞拉利昂'
    },
    {
      'code': 'SM',
      'en': 'San Marino',
      'name': '聖馬力諾'
    },
    {
      'code': 'SN',
      'en': 'Senegal',
      'name': '塞內加爾'
    },
    {
      'code': 'SO',
      'en': 'Somalia',
      'name': '索馬裏'
    },
    {
      'code': 'SR',
      'en': 'Suriname',
      'name': '蘇裏南'
    },
    {
      'code': 'SS',
      'en': 'South Sudan',
      'name': '南蘇丹'
    },
    {
      'code': 'ST',
      'en': 'Sao Tome & Principe',
      'name': '聖多美和普林西比'
    },
    {
      'code': 'SV',
      'en': 'El Salvador',
      'name': '薩爾瓦多'
    },
    {
      'code': 'SX',
      'en': 'Sint Maarten',
      'name': '荷屬聖馬丁'
    },
    {
      'code': 'SY',
      'en': 'Syria',
      'name': '敘利亞'
    },
    {
      'code': 'SZ',
      'en': 'Swaziland',
      'name': '斯威士蘭'
    },
    {
      'code': 'TW',
      'en': 'TaiWan',
      'name': '臺灣'
    },
    {
      'code': 'TC',
      'en': 'Turks & Caicos Islands',
      'name': '特克斯和凱科斯群島'
    },
    {
      'code': 'TD',
      'en': 'Chad',
      'name': '乍得'
    },
    {
      'code': 'TF',
      'en': 'French Southern Territories',
      'name': '法屬南部領地'
    },
    {
      'code': 'TG',
      'en': 'Togo',
      'name': '多哥'
    },
    {
      'code': 'TH',
      'en': 'Thailand',
      'name': '泰國'
    },
    {
      'code': 'TJ',
      'en': 'Tajikistan',
      'name': '塔吉克斯坦'
    },
    {
      'code': 'TK',
      'en': 'Tokelau',
      'name': '托克勞'
    },
    {
      'code': 'TL',
      'en': 'Timor-Leste (East Timor)',
      'name': '東帝汶'
    },
    {
      'code': 'TM',
      'en': 'Turkmenistan',
      'name': '土庫曼斯坦'
    },
    {
      'code': 'TN',
      'en': 'Tunisia',
      'name': '突尼斯'
    },
    {
      'code': 'TO',
      'en': 'Tonga',
      'name': '湯加'
    },
    {
      'code': 'TR',
      'en': 'Turkey',
      'name': '土耳其'
    },
    {
      'code': 'TT',
      'en': 'Trinidad & Tobago',
      'name': '特立尼達和多巴哥'
    },
    {
      'code': 'TV',
      'en': 'Tuvalu',
      'name': '圖瓦盧'
    },
    {
      'code': 'TZ',
      'en': 'Tanzania',
      'name': '坦桑尼亞'
    },
    {
      'code': 'UA',
      'en': 'Ukraine',
      'name': '烏克蘭'
    },
    {
      'code': 'UG',
      'en': 'Uganda',
      'name': '烏幹達'
    },
    {
      'code': 'UM',
      'en': 'United States Minor Outlying Islands',
      'name': '美國本土外小島嶼'
    },
    {
      'code': 'UY',
      'en': 'Uruguay',
      'name': '烏拉圭'
    },
    {
      'code': 'UZ',
      'en': 'Uzbekistan',
      'name': '烏茲別克斯坦'
    },
    {
      'code': 'VA',
      'en': 'Vatican City (The Holy See)',
      'name': '梵蒂岡'
    },
    {
      'code': 'VC',
      'en': 'St. Vincent & the Grenadines',
      'name': '聖文森特和格林納丁斯'
    },
    {
      'code': 'VE',
      'en': 'Venezuela',
      'name': '委內瑞拉'
    },
    {
      'code': 'VG',
      'en': 'British Virgin Islands',
      'name': '英屬維爾京群島'
    },
    {
      'code': 'VI',
      'en': 'United States Virgin Islands',
      'name': '美屬維爾京群島'
    },
    {
      'code': 'VN',
      'en': 'Vietnam',
      'name': '越南'
    },
    {
      'code': 'VU',
      'en': 'Vanuatu',
      'name': '瓦努阿圖'
    },
    {
      'code': 'WF',
      'en': 'Wallis and Futuna',
      'name': '瓦利斯和富圖納'
    },
    {
      'code': 'WS',
      'en': 'Samoa',
      'name': '薩摩亞'
    },
    {
      'code': 'YE',
      'en': 'Yemen',
      'name': '也門'
    },
    {
      'code': 'YT',
      'en': 'Mayotte',
      'name': '馬約特'
    },
    {
      'code': 'ZA',
      'en': 'South Africa',
      'name': '南非'
    },
    {
      'code': 'ZM',
      'en': 'Zambia',
      'name': '贊比亞'
    },
    {
      'code': 'ZW',
      'en': 'Zimbabwe',
      'name': '津巴布韋'
    }
  ]

  return countryData
}



// WEBPACK FOOTER //
// ./src/utils/country.js